import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=df439596&scoped=true"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"
import style0 from "../_layout.css?vue&type=style&index=0&id=df439596&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df439596",
  null
  
)

export default component.exports